var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuickOrderSubmitted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 300,
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_222_39101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135 453.9C173.6 400.2 241.6 377.5 306 377.6C370.4 377.7 432.3 402.5 489.7 431.8C547.1 461.1 602.2 495.5 662.8 517.5C700.3 531.1 739.5 539.9 776.9 553.6C814.4 567.3 851 586.9 876.4 617.6C901.3 647.7 913.6 691 897.8 726.7C891.4 741.1 881 753.3 869 763.5C831.4 795.3 779.6 806 730.5 803.2C681.4 800.3 633.9 785.1 587.1 769.9C540.3 754.7 492.9 739.4 443.8 736.3C376.7 732.1 307.3 750.8 243 730.8C189.3 714.1 145.4 680.8 117.5 632C109 617.1 102.8 592.1 100.2 575.2C96.3999 550.6 102.9 525.7 109.3 501.7C113.2 487.4 121.2 472.7 135 453.9Z",
    fill: "url(#paint0_linear_222_39101)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8 241C112.4 177.7 196.1 153.5 274.4 157C352.7 160.5 426.6 193.7 494.8 232.2C563 270.7 628.3 315.3 700.7 345.2C745.6 363.6 792.7 376.2 837.6 394.8C882.5 413.4 925.9 439 955.2 477.6C983.9 515.4 996.7 568.7 975.7 611.3C967.2 628.4 953.9 642.8 938.8 654.5C891.5 691.2 828.1 701.7 768.5 695.7C709 689.7 652.1 668.7 596 647.9C539.9 627.1 483 606 423.6 599.8C342.2 591.3 257 610.5 180.1 582.9C115.8 559.9 66.5 519.9 35.1 459.2C25.5 440.7 16.8 407.2 14.5 386.6C11.1 356.5 20.3 326.7 29.3 297.8C34.7 280.7 45.2 263.2 63 241",
    fill: "url(#paint1_linear_222_39101)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773 947.3H227C204.4 947.3 186 929 186 906.3V85.7002C186 63.1002 204.3 44.7002 227 44.7002H773C795.6 44.7002 814 63.0002 814 85.7002V906.3C814 929 795.6 947.3 773 947.3Z",
    stroke: "#5B96C5",
    strokeWidth: 10,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.8 294.3H355V322.7H717.8V294.3Z",
    fill: "url(#paint2_linear_222_39101)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319 290.1H282.2V326.9H319V290.1Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.8 467.4H355V495.8H717.8V467.4Z",
    fill: "url(#paint3_linear_222_39101)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319 463.2H282.2V500H319V463.2Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.8 640.5H355V668.9H717.8V640.5Z",
    fill: "url(#paint4_linear_222_39101)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319 636.3H282.2V673.1H319V636.3Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.8 323.8L300.9 325.2L302.6 323.2L349 264.9L341.9 259.2L300.7 311L283.3 290.8L276.4 296.7L299.8 323.8Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.8 498.7L300.9 500L302.6 498L349 439.7L341.9 434.1L300.7 485.9L283.3 465.6L276.4 471.6L299.8 498.7Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.8 671.8L300.9 673.1L302.6 671.1L349 612.8L341.9 607.2L300.7 659L283.3 638.7L276.4 644.7L299.8 671.8Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_222_39101",
    x1: 861.633,
    y1: 826.387,
    x2: 119.156,
    y2: 391.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00670616,
    stopColor: "#FEF3ED",
    stopOpacity: 0.2178
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0389905,
    stopColor: "#F7CCB7",
    stopOpacity: 0.3035
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0718789,
    stopColor: "#F2AB8D",
    stopOpacity: 0.3908
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1048,
    stopColor: "#EE9270",
    stopOpacity: 0.4781
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1377,
    stopColor: "#EB805C",
    stopOpacity: 0.5655
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    stopColor: "#EA724D",
    stopOpacity: 0.6531
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2039,
    stopColor: "#E86944",
    stopOpacity: 0.7411
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2374,
    stopColor: "#E86641",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#E86641",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E86641",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E86641",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E86641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_222_39101",
    x1: 13.8963,
    y1: 427.138,
    x2: 986.111,
    y2: 427.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_222_39101",
    x1: 355.045,
    y1: 308.509,
    x2: 717.803,
    y2: 308.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_222_39101",
    x1: 355.045,
    y1: 481.616,
    x2: 717.803,
    y2: 481.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_222_39101",
    x1: 355.045,
    y1: 654.723,
    x2: 717.803,
    y2: 654.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40719D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_222_39101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickOrderSubmitted);
export default __webpack_public_path__ + "static/media/quick-order-submitted.2fb7739203e3316bee7a559aacc0731e.svg";
export { ForwardRef as ReactComponent };